export const BOOKING_STATUS = {
  WAITING: 'waiting',
  CONFIRMED: 'confirmed',
  CANCEL: 'cancel',
  PENDING_PAYMENT: 'pendingPayment',
  PENDING_CHECK_SLIP: 'pendingCheckSlip',
  INVALID_SLIP: 'invalidSlip',
  PENDING_APPROVE: 'pendingApprove'
};

export const statusMap = {
  isWaiting: 'booking2.status.waiting',
  isConfirm: 'booking2.status.confirmed',
  isCancel: 'booking2.status.cancel',
  isPendingCheckSlip: 'booking2.status.pendingCheckSlip',
  isPendingPayment: 'booking2.status.pendingPayment',
  isInvalidSlip: 'booking2.status.invalidSlip',
  isPendingApprove: 'booking2.status.pendingApprove'
};

export const BookingStatus = translate => [
  {
    value: BOOKING_STATUS.WAITING,
    text: translate('booking2.status.waiting')
  },
  {
    value: BOOKING_STATUS.CONFIRMED,
    text: translate('booking2.status.confirmed')
  },
  {
    value: BOOKING_STATUS.CANCEL,
    text: translate('booking2.status.cancel')
  },
  {
    value: BOOKING_STATUS.PENDING_APPROVE,
    text: translate('booking2.status.pendingApprove')
  },
  {
    value: BOOKING_STATUS.PENDING_CHECK_SLIP,
    text: translate('booking2.status.pendingCheckSlip')
  },
  {
    value: BOOKING_STATUS.PENDING_PAYMENT,
    text: translate('booking2.status.pendingPayment')
  },
  {
    value: BOOKING_STATUS.INVALID_SLIP,
    text: translate('booking2.status.invalidSlip')
  }
];
